import React from 'react';
import Select from 'react-select';

const InputField = ({ label, placeholder, name, value, data, type, required, onChange, disabled, className, register, errors, setSingleValueAsDefault, defaultValue, multiple, subScriptHeading }) => {

    const inputId = label.toLowerCase().replace(/\s+/g, '-');

    return (
        <div className="flex flex-col flex-1 grow shrink-0 basis-0 min-h-[65px] w-full mt-2">
            <label htmlFor={inputId} className="gap-1 self-stretch text-base w-full text-gray-900 font-semibold capitalize">
                {required && <span className="text-red">* </span>}
                {label}
                <small className='text-secondary'>{subScriptHeading}</small>
            </label>
            <div className="flex gap-2.5 items-center mt-1 w-full bg-white rounded-md border border-solid border-navBtn text-slate-400">
                {type === 'select' ? (
                    <select
                        id={inputId}
                        className="flex-1 select2 shrink self-stretch my-auto basis-0 px-4 py-2.5 outline-primary rounded-md capitalize text-base"
                        aria-label={label}
                        name={name}
                        onChange={onChange}
                        disabled={disabled}
                        value={((required === true || setSingleValueAsDefault === true) && (Array.isArray(data) ? data.length : 0) === 1) ? data[0].value : value}
                        // {...register(name)}
                    >
                        <option value={''}>{placeholder}</option>
                        {data && data.map((d, index) => (
                            <option value={d.value} key={index} defaultValue={d.selected ? true : false}>{d.placeholder}</option>
                        ))}
                    </select>
                    // <Select
                    //     options={data && data.map((d) => (
                    //         { value: d.value, label: d.placeholder }
                    //     ))}
                    //     className="flex-1 shrink self-stretch my-auto basis-0 bg-transparent border-none outline-none text-base"
                    //     name={name}
                    //     onChange={onChange}
                    //     value={value}
                    //     // defaultValue={defaultValue ? { value: defaultValue, label: defaultValue } : null}
                    //     defaultValue={defaultValue ? defaultValue : null}
                    //     placeholder={placeholder}
                    //     isMulti={multiple ?? false}
                    //     styles={{
                    //         control: (base) => ({
                    //             ...base,
                    //             backgroundColor: 'transparent',
                    //             border: '1px solid rgba(224, 230, 237, 1)',
                    //             borderRadius: '0.375rem',
                    //             boxShadow: 'none',
                    //             padding: '0.25rem',
                    //             ":hover": {
                    //                 borderColor: '#16ad3c',
                    //             },
                    //         }),
                    //         menu: (base) => ({
                    //             ...base,
                    //             zIndex: 9999,
                    //         }),
                    //         option: (base, { isSelected }) => ({
                    //             ...base,
                    //             backgroundColor: isSelected ? '#16ad3c' : 'white', // Custom background for selected option
                    //             color: isSelected ? 'white' : 'black', // Custom text color for selected option
                    //             ":active": {
                    //                 backgroundColor: isSelected ? '#16ad3c' : 'rgba(0, 0, 0, 0.1)', // Active state
                    //             },
                    //             ":hover": {
                    //                 backgroundColor: isSelected ? '#16ad3c' : 'rgba(52, 199, 89, 0.3)', // Hover state
                    //             },
                    //         }),
                    //         singleValue: (base) => ({
                    //             ...base,
                    //             color: 'black',
                    //         }),
                    //         placeholder: (base) => ({
                    //             ...base,
                    //             color: 'gray',
                    //         }),
                    //         dropdownIndicator: (base) => ({
                    //             ...base,
                    //             color: 'gray',
                    //         }),
                    //         indicatorSeparator: (base) => ({
                    //             ...base,
                    //             display: 'none',
                    //         }),
                    //         clearIndicator: (base) => ({
                    //             ...base,
                    //             color: 'gray',
                    //         }),
                    //         valueContainer: (base) => ({
                    //             ...base,
                    //             padding: '0.25rem',
                    //         }),
                    //         input: (base) => ({
                    //             ...base,
                    //             color: 'black',
                    //         }),
                    //         menuList: (base) => ({
                    //             ...base,
                    //             maxHeight: '200px',
                    //         }),
                    //     }}
                    // />
                ) : (
                    <input
                        id={inputId}
                        type={type}
                        name={name}
                        placeholder={placeholder}
                        className={`flex-1 shrink self-stretch my-auto basis-0 outline-primary px-4 py-2.5 rounded-md text-base ${className}`}
                        aria-label={label}
                        required={required}
                        value={value}
                        onChange={onChange}
                        disabled={disabled}
                        {...(type === 'number' ? { inputMode: 'numeric', pattern: '[0-9]*' } : {})}
                        min="0"
                        onWheel={(e) => e.target.blur()}
                    />
                )}
            </div>
            {/* {errors[name] && (
                <div className="text-red text-sm mt-1">{errors[name].message}</div>
            )} */}
        </div>
    );
};

export default InputField;